var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
var ListItemLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #212121;\n  text-decoration: none;\n"], ["\n  color: #212121;\n  text-decoration: none;\n"])));
var LinkListItem = function (_a) {
    var href = _a.href, icon = _a.icon, text = _a.text, onClick = _a.onClick;
    return (React.createElement(ListItemLink, { to: href, onClick: onClick },
        React.createElement(ListItem, { button: true },
            React.createElement(ListItemIcon, null, icon),
            React.createElement(ListItemText, { primary: text }))));
};
export default LinkListItem;
var templateObject_1;
